import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/** Gate for authed routes. Two conditions used to be enforced here (Cognito
 *  session + `beta`/`admin` group membership); as of 2026-08-17 (open beta)
 *  only the session check remains. Any signed-in user gets in — the backend
 *  no longer requires a group either. `admin` group is still used ad-hoc
 *  for admin-only bypasses (unlimited balance, storage-quota bypass) but
 *  it's not a gate for accessing the app itself.
 */
const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { ready, isAuthenticated, signIn } = useAuth();

  React.useEffect(() => {
    if (ready && !isAuthenticated) signIn();
  }, [ready, isAuthenticated, signIn]);

  if (!ready || !isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-space-950 text-white/60">
        <Loader2 className="h-6 w-6 animate-spin mr-2" />
        <span className="text-sm">Signing you in…</span>
      </div>
    );
  }
  return <>{children}</>;
};

export default RequireAuth;
